import { createContext, useContext, ReactNode, useState, useEffect } from "react";

interface IsOnlineContextType {
  isOnline: boolean;
}

const IsOnlineContext = createContext<IsOnlineContextType>({ isOnline: true });

export const IsOnlineProvider = ({ children }: { children: ReactNode }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <IsOnlineContext.Provider value={{ isOnline }}>
      {children}
    </IsOnlineContext.Provider>
  );
};

export const useIsOnline = () => {
  const context = useContext(IsOnlineContext);
  if (!context) {
    throw new Error("useIsOnline must be used within IsOnlineProvider");
  }
  return context;
};
